class StickyATC {
  constructor(productInfo) {
    this.sectionId = productInfo.dataset.section;
    this.bar = productInfo.querySelector('.product-sticky-atc');
    this.ctaZone = productInfo.querySelector('.product__cta-zone') || productInfo.querySelector('product-form');
    this.stickyPrice = productInfo.querySelector('.product-sticky-atc__price');
    this.mainPrice = productInfo.querySelector(`#price-${this.sectionId}`);
    this.mainQty = productInfo.querySelector(`#Quantity-${this.sectionId}`);

    if (!this.bar || !this.ctaZone) return;

    this.setupVisibility();
    this.setupPriceSync();
    this.setupQtySync();
  }

  setupVisibility() {
    new IntersectionObserver(
      ([entry]) => {
        const show = !entry.isIntersecting;
        this.bar.setAttribute('aria-hidden', String(!show));
        this.bar.classList.toggle('product-sticky-atc--visible', show);
      },
      { threshold: 0 }
    ).observe(this.ctaZone);
  }

  setupPriceSync() {
    if (!this.mainPrice || !this.stickyPrice) return;
    new MutationObserver(() => {
      this.stickyPrice.innerHTML = this.mainPrice.innerHTML;
    }).observe(this.mainPrice, { childList: true, subtree: true, characterData: true });
  }

  setupQtySync() {
    if (!this.mainQty) return;

    const display = this.bar.querySelector('.product-sticky-atc__qty-val');
    const minus = this.bar.querySelector('[data-sticky-qty="minus"]');
    const plus = this.bar.querySelector('[data-sticky-qty="plus"]');

    if (!display || !minus || !plus) return;

    // Keep sticky display in sync when main input changes
    const sync = () => { display.textContent = this.mainQty.value; };
    this.mainQty.addEventListener('change', sync);
    this.mainQty.addEventListener('input', sync);

    minus.addEventListener('click', () => {
      const min = parseInt(this.mainQty.min) || 1;
      const val = Math.max(min, parseInt(this.mainQty.value) - 1);
      this.mainQty.value = val;
      display.textContent = val;
      this.mainQty.dispatchEvent(new Event('change', { bubbles: true }));
    });

    plus.addEventListener('click', () => {
      const max = this.mainQty.max ? parseInt(this.mainQty.max) : Infinity;
      const val = Math.min(max, parseInt(this.mainQty.value) + 1);
      this.mainQty.value = val;
      display.textContent = val;
      this.mainQty.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
}

document.querySelectorAll('product-info').forEach(el => new StickyATC(el));
